import Vue from 'vue'
import Vuex from 'vuex'
import kiosk from '@/stores/kiosk.store'
import common from '@/stores/common.store'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: { kiosk, common }
})
